// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image[data-v-e8eb6340] {\n  width: 160px;\n  height: 160px;\n}\n.mb-10[data-v-e8eb6340] {\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
